import styled from "styled-components";

import { inputCss } from "./styles";

export const TextArea = styled.textarea`
  ${inputCss}
  resize: none;
`;
